var plugin_rtlignore_default = {
  "alignLeft": "pxtFR",
  "textWrapNowrap": "bjHyD",
  "alignRight": "U-ULk",
  "alignCenter": "ROokS",
  "sizeFullWidth": "aH2tC",
  "renderedInTable": "pdEOh",
  "sizeOriginal": "Vpbl6",
  "sizeContent": "Ll2MW",
  "sizeSmall": "plAUx",
  "sizeSmallCenter": "bYfS7",
  "flex": "D-Uqf",
  "atomic": "nLTIx",
  "embed": "FcwDn",
  "horizontalScrollbar": "EbS8l",
  "pluginContainerMobile": "mGDg3"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
